export const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: 'bi-speedometer2', requiredAction: 'dashboard.read' },
  { to: '/admin/flows', label: 'Workflows', icon: 'bi-diagram-3', requiredAction: 'workflows.read' },
  { to: '/admin/assets', label: 'Assets', icon: 'bi-boombox', requiredAction: 'assets.read' },
  { to: '/admin/tasks', label: 'Tasks', icon: 'bi-list-task', requiredAction: 'tasks.read' },
  { to: '/admin/short-urls', label: 'Access URLs', icon: 'bi-qr-code', requiredAction: 'short_urls.read' },
  // Kits + Kit codes (/admin/kits, /admin/kit-batches): hidden until backend is ready
  { to: '/admin/users', label: 'Users', icon: 'bi-people', requiredAction: 'users.list' },
  { to: '/admin/releases', label: 'Releases', icon: 'bi-rss', requiredAction: 'dashboard.read' },
  { to: '/admin/reports/tasks', label: 'Reports', icon: 'bi-graph-up', requiredAction: 'reports.read' }
];

// The Organization settings group. One list, rendered three ways: as a collapsible group when
// the sidebar is expanded, as a single "Org settings" rail item when it is collapsed, and as the
// target of that item (the first entry the user is allowed to see). It used to be written out
// twice in AdminSidebar, once per sidebar state, which is why the two copies had drifted into
// giving Forms and Document library the same icon.
// `description` is for the landing page's cards, where there is room to say what a page is for
// and the sidebar's one-word label on its own would make seven near-identical cards.
export const orgSettingsItems = [
  {
    to: '/admin/organization/forms',
    label: 'Forms',
    icon: 'bi-ui-checks',
    description: 'The question sets a workflow step can put in front of a field engineer.',
  },
  {
    to: '/admin/organization/media-library',
    label: 'Media library',
    icon: 'bi-images',
    description: 'Images and video a workflow step can show.',
  },
  {
    to: '/admin/organization/document-library',
    label: 'Document library',
    icon: 'bi-file-earmark-text',
    description: 'Manuals and datasheets, and what the assistant is allowed to read.',
  },
  {
    to: '/admin/organization/ai',
    label: 'AI',
    icon: 'bi-robot',
    description: 'How the assistant behaves for field engineers, and what it has indexed.',
  },
  {
    to: '/admin/organization/tags',
    label: 'Tags',
    icon: 'bi-tags',
    requiredAction: 'tags.manage',
    description: 'The tag tree that scopes workflows to assets.',
  },
  {
    to: '/admin/organization/integrations',
    label: 'Integrations',
    icon: 'bi-plug',
    requiredAction: 'integrations.manage',
    description: 'Connections to ticketing and charge-point systems.',
  },
  {
    to: '/admin/organization/api-tokens',
    label: 'API tokens',
    icon: 'bi-key',
    requiredAction: 'api_tokens.manage',
    description: 'Machine credentials for calling the admin API.',
  },
];

// Every settings page lives under this prefix, so the collapsed rail item can light up for any
// of them without listing them again. The prefix itself is the group's landing page.
export const ORG_SETTINGS_PATH_PREFIX = '/admin/organization';
